// import type { Schema } from "common/backend/amplify/data/resource";

// type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

// export type Play = PartialBy<Schema['Play']['type'], "createdAt" | "updatedAt">
// export type Position = Schema['Position']['type']
// export type Snapshot = Schema['Snapshot']['type']
// type UserLicense = Schema['UserLicense']['type'];

export type Play = {
  id?: string
  name: string
  category: string
  folderId?: string | null
  snapshots: Snapshot[]
  namings?: (string | null)[]
  createdAt?: string
  updatedAt?: string
  owner?: string
  licenseGroup?: string
}

export type Position = {
  x: number
  y: number
}

// Recorded drag trail for one piece, in pool-metre coordinates.
// Shape mirrors the backend PiecePath customType exactly so the same object
// flows through the store, the offline cache and the AppSync client unmapped.
export type PiecePath = {
  points: Position[]
}

// Per-piece paths describing how pieces travel FROM the previous snapshot TO
// the snapshot holding this value. Sparse: null/missing entries mean the
// piece moves linearly. Arrays are index-aligned with the Snapshot arrays.
export type PathSet = {
  players?: (PiecePath | null)[]
  opponents?: (PiecePath | null)[]
  goalkeepers?: (PiecePath | null)[]
  ball?: PiecePath | null
}

export type Snapshot = {
  players: Position[]
  opponents: Position[]
  goalkeepers: Position[]
  ball: Position
  paths?: PathSet | null
}

export interface Dimension {
  width: number | string
  height: number | string
}

export type Placement = Dimension & {
  x: number | string
  y: number | string
}
export type Formation = Play

export enum LicenseType {
  FREE = "free",
  INDIVIDUAL = "individual",
  CLUB = "club"
}

export type UserLicense = {
  id?: string
  email: string
  firstName: string
  lastName: string
  isFreeApp?: boolean
  licenseType: LicenseType
  licenseKey: string
  licenseGroupId: string
  club: string
  licenseValidFor: string
  maxLicenseQuota: number
  createdAt?: string
  updatedAt?: string
}

export type PlayFolder = {
  id?: string
  name: string
  description: string
  licenseGroup?: string
}

export type Syncable<T> = T & { synced?: boolean, isDraft?: boolean };
